module.exports = __webpack_public_path__ + "static/media/lacruz-mockup.e292f5ae.png";